import { createRoot } from 'react-dom/client'
import './styles/app.css'
import App from './App'
import { StoreProvider } from './state/store'
import { UIProvider } from './state/ui'

// No StrictMode: the app runs a wall-clock rest timer and fires optimistic writes; double-invoke
// would double the timers/writes. Idempotency is preserved without it.
createRoot(document.getElementById('root')!).render(
  <StoreProvider>
    <UIProvider>
      <App />
    </UIProvider>
  </StoreProvider>,
)
